import React, { Fragment, useEffect } from "react";


import Header from "../Components/Header";
import Footer from "../Components/Footer";
import { NavLink } from "react-router-dom";

const DownloadFinestpayApp = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Handle Download Buttons
  const handleDownload = (platform) => {
    if (platform === "android") {
      window.open(
        "https://play.google.com/store/apps/details?id=com.org.finestpay",
        "_blank"
      );
    } else if (platform === "ios") {
      window.open(
        "https://apps.apple.com",
        "_blank"
      );
    }
  };

  return (
    <Fragment>
      <div className="page-wrapper">
        <Header />

        {/* ===== Hero Section ===== */}
       {/* Breadcrumb start */}
              <div className="breadcrumb-wrap bg-f">
                <div className="overlay bg-vulcan op-9" />
                <div className="container">
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="breadcrumb-title">
                        <h2>Download the FinestPay App</h2>
                        <ul className="breadcrumb-menu list-style">
                          <li>
                            <NavLink to="/">Home </NavLink>
                          </li>
                          <li>Download the FinestPay App</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Breadcrumb end */}

        {/* ===== Download Section ===== */}
        <section
          style={{
            padding: "80px 0",
            background: "linear-gradient(135deg, #fff, #f8f9fa)",
          }}
        >
          <div
            className="container"
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "50px",
            }}
          >
            {/* LEFT SIDE – QR + Buttons */}
            <div
              style={{
                flex: "1",
                minWidth: "330px",
                background: "#fff",
                padding: "35px",
                borderRadius: "20px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.07)",
              }}
            >
              {/* Badge */}
              <span
                style={{
                  display: "inline-block",
                  padding: "6px 16px",
                  background: "#FF414B",
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: "600",
                  borderRadius: "30px",
                  marginBottom: "15px",
                }}
              >
                AVAILABLE NOW
              </span>

              {/* Heading */}
              <h3
                style={{
                  fontSize: "30px",
                  color: "#111",
                  fontWeight: "700",
                  marginBottom: "10px",
                }}
              >
                Transfer Money Anytime
              </h3>

              <p style={{ color: "#555", marginBottom: "30px" }}>
                Scan the QR code to download the Finestpay App.  
                Enjoy fast transfers, the best exchange rates, and secure transactions.
              </p>

              {/* QR Cards */}
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  flexWrap: "wrap",
                }}
              >
                {/* ANDROID */}
                <div
                  style={{
                    flex: "1",
                    minWidth: "150px",
                    background: "#fff",
                    borderRadius: "20px",
                    padding: "20px",
                    textAlign: "center",
                    border: "2px solid transparent",
                    backgroundImage: `
                      linear-gradient(#fff, #fff),
                      linear-gradient(135deg, #FF414B, #ff767e, #FF414B)
                    `,
                    backgroundOrigin: "border-box",
                    backgroundClip: "padding-box, border-box",
                    boxShadow: "0 20px 30px rgba(255, 65, 75, 0.25)",
                  }}
                >
                  <h4
                    style={{
                      color: "#111",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    Google Play
                  </h4>

                  <img
                    src="assets/googleplayqr.png"
                    alt="Android QR"
                    style={{
                      width: "130px",
                      margin: "12px auto",
                      display: "block",
                    }}
                  />

                <NavLink to="https://play.google.com/store/apps/details?id=com.remit.FinestPayMoney" target="_blank">
                                           <img src="assets/img/android.png" />
                                         </NavLink>
                </div>

                {/* IOS */}
                <div
                  style={{
                    flex: "1",
                    minWidth: "150px",
                    background: "#fff",
                    borderRadius: "20px",
                    padding: "20px",
                    textAlign: "center",
                    border: "2px solid transparent",
                    backgroundImage: `
                      linear-gradient(#fff, #fff),
                      linear-gradient(135deg, #111, #444, #111)
                    `,
                    backgroundOrigin: "border-box",
                    backgroundClip: "padding-box, border-box",
                    boxShadow: "0 20px 30px rgba(0,0,0,0.25)",
                  }}
                >
                  <h4
                    style={{
                      color: "#111",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                  >
                    App Store
                  </h4>

                  <img
                    src="assets/appleqrcode.png"
                    alt="iOS QR"
                    style={{
                      width: "130px",
                      margin: "12px auto",
                      display: "block",
                    }}
                  />

                 <div className="about-img-text">
                                         <NavLink to="https://apps.apple.com/app/finestpay/id6739626344" target="_blank">
                                           <img src="assets/img/apple.png" />
                                         </NavLink>
                                       </div>
                </div>
              </div>
            </div>

            {/* RIGHT SIDE IMAGE */}
            {/* <div
              style={{
                flex: "1",
                minWidth: "300px",
                textAlign: "center",
              }}
            >
              <img
                src="/images/app/finestpay-mobile.png"
                alt="Finestpay Mobile App"
                style={{
                  width: "100%",
                  maxWidth: "460px",
                  borderRadius: "20px",
                }}
              />
            </div> */}
          </div>
        </section>

        <Footer />
       
      </div>
    </Fragment>
  );
};

export default DownloadFinestpayApp;
